import {
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
} from "reactstrap";
import RenderFields from "./RenderFields";
import { useEffect } from "react";
import { GetTenantDetails, postDataFromApi, putDataFromApi } from "../../services/commonServices";
import { labGroupsStdBasisApi, labOPEGroupsStdBasisApi, labOPEparambasisApi, labparambasisApi, sampleInwardDetailsUpdateAPI, sampleInwardSetDetailsUpdateAPI } from "../../services/api";
import { toast } from "react-toastify";
const parameterEditableFields = {
    headers: [
        { label: "Parameter", name: "smpl_set_paramjson" },
        { label: "Test Method", name: "smpl_set_testmethodjson" },
        { label: "Basis", name: "smpl_set_basisjson" },
        { label: "Unit", name: "smpl_set_unit" },
    ],
    rows: [
        {
            name: "smpl_set_paramjson",
            type: "select",
        },
        {
            name: "smpl_set_testmethodjson",
            type: "select",
        },
        {
            name: "smpl_set_basisjson",
            type: "select",
            isMultiple: true
        },
        {
            name: "smpl_set_unit",
            type: "select",
        },
    ],
};

const EditabeAssignmentParam = ({
    setIsLoading,
    isLoading,
    Loader,
    editableFormData,
    setEditableFormData,
    updatedMasterOptions,
    formData,
    setUpdatedMasterOptions,
    sampleDataTable,
    finalParamDataSort,
    setFinalParamDataSort,
    setSampleDataTable,
    editableSetIndex,
    setIsEditableSetRow,
    moduleType,
    getInwardTabledata,
    setParameterDataTable,
    setCustomFormData,
    initialCustomData,
    setIsSubmit,
    setIsOverlayLoader
}) => {
    const onHandleChangeParam = async () => {
        try {
            let newfinalParamDataSort = []
            let newsampleDataTable = []
            let basiscode = [];

            // updatedMasterOptions?.forEach((model) => {
            //     if (model.model === "smpl_set_basisjson" && basiscode.length === 0) {
            //         model.data
            //             .filter((singleData) =>
            //                 editableFormData[0]?.smpl_set_basisjson?.includes(singleData.id)
            //             )
            //             .forEach((singleData) => {
            //                 basiscode.push({
            //                     basis_code: singleData.name,
            //                     basis_id: singleData.id,
            //                 });
            //             });
            //     }
            // });

            // if (!basiscode.length || !editableFormData[0]?.smpl_set_testmethodjson) {
            //     toast.error("Test method and basis are required", {
            //         position: "top-right",
            //         autoClose: 2000,
            //         hideProgressBar: false,
            //         closeOnClick: true,
            //         pauseOnHover: true,
            //         draggable: true,
            //         progress: undefined,
            //         theme: "light",
            //     });
            //     return
            // }
            let paramjson = []
            let groupJson = []
            if (editableFormData[0]?.is_group) {

                const updatedSet = finalParamDataSort[editableSetIndex].map((group) => {
                    if (group.group_id != editableFormData[0]?.group_id) {
                        return group;
                    }

                    return {
                        ...group,
                        parameters: group.parameters.map((param) => {
                            if (param.param_id != editableFormData[0]?.smpl_set_paramjson) {
                                return param;
                            }

                            return {
                                ...param,
                                param_unit: editableFormData[0]?.smpl_set_unit,
                                standards: [
                                    {
                                        std_id: editableFormData[0]?.smpl_set_testmethodjson,
                                        std_name: editableFormData[0]?.smpl_set_testmethodjson_name,
                                    },
                                ],
                                basis: editableFormData[0]?.sample_set_basis,
                            };
                        }),
                    };
                });
                if (!formData[0]?.sample_set_data?.length) {
                    setFinalParamDataSort((prev) => {
                        const updated = [...prev];
                        updated[editableSetIndex] = updatedSet;
                        return updated;
                    });
                    setSampleDataTable((prev) => {
                        const updated = [...prev];

                        updated[editableSetIndex] = {
                            ...updated[editableSetIndex],
                            smpl_set_groupjson: updatedSet.filter((param) => param.param_type != "Parameter"),
                        };
                        return updated;
                    });
                }
                paramjson = updatedSet.filter((param) => param.param_type == "Parameter")
                groupJson = updatedSet.filter((param) => param.param_type != "Parameter")
            }
            else {
                const updatedSet = finalParamDataSort[editableSetIndex].map((param) => {
                    if (param.param_id == editableFormData[0]?.smpl_set_paramjson) {
                        return {
                            ...param,
                            param_unit: editableFormData[0]?.smpl_set_unit,
                            std_id: editableFormData[0]?.smpl_set_testmethodjson,
                            std_name: editableFormData[0]?.smpl_set_testmethodjson_name,
                            basis: editableFormData[0]?.sample_set_basis,
                        };
                    }

                    return param;
                });
                if (!formData[0]?.sample_set_data?.length) {
                    setFinalParamDataSort((prev) => {
                        const updated = [...prev];
                        updated[editableSetIndex] = updatedSet;
                        return updated;
                    });
                    setSampleDataTable((prev) => {
                        const updated = [...prev];

                        updated[editableSetIndex] = {
                            ...updated[editableSetIndex],
                            smpl_set_paramjson: updatedSet.filter((param) => param.param_type != "Group")
                        };

                        return updated;
                    });
                }
                groupJson = updatedSet.filter((param) => param.param_type == "Group")
                paramjson = updatedSet.filter((param) => param.param_type != "Group")

            }
            if (formData[0]?.sample_set_data?.length) {
                await handleSampleInwardSetUpdate(groupJson, paramjson)
            }
            setTimeout(() => {
                setIsEditableSetRow(false)
            }, 10)
        }
        catch {

        }
    }
    useEffect(() => {
        if (editableFormData[0]?.smpl_set_paramjson)
            getGroupParameterMasterData()
    }, [editableFormData[0]?.smpl_set_paramjson])
    useEffect(() => {
        if (editableFormData[0]?.smpl_set_testmethodjson)
            getGroupParameterMasterDataWithTestMethod()
    }, [editableFormData[0]?.smpl_set_testmethodjson])
    const getGroupParameterMasterDataWithTestMethod = async (
        value
    ) => {
        try {
            setIsLoading(true);
            let tempBody = {
                lab_id: formData[1].jrf_lab,
                commodity_id: formData[1].jrf_commodity,
                sub_commodity_id: formData[1].fk_sub_commodity,
                param_id: editableFormData[0]?.smpl_set_paramjson,
                group_id: editableFormData[0]?.group_id,
                std_id: editableFormData[0]?.smpl_set_testmethodjson

            };
            let res = await postDataFromApi(labOPEparambasisApi, tempBody);
            if (res.data && res.data.status == 200) {
                const actualResponse = res.data.data;

                let basis = actualResponse.basis || [];
                basis = basis.map((item) => ({
                    ...item,
                    name: item.basis_code,
                    id: item.basis_id,
                }));

                setUpdatedMasterOptions((prev) => {
                    const index = prev.findIndex(
                        (item) => item.model === "smpl_set_basisjson"
                    );

                    if (index !== -1) {
                        const updated = [...prev];
                        updated[index] = {
                            ...updated[index],
                            data: basis,
                        };
                        return updated;
                    }

                    return [
                        ...prev,
                        {
                            model: "smpl_set_basisjson",
                            data: basis,
                        },
                    ];
                });
            }
        } catch (error) { }
        setTimeout(() => {
            setIsLoading(false);
        }, [10]);
    };
    const getGroupParameterMasterData = async (value) => {

        try {
            setIsLoading(true);
            let tempBody = {
                lab_id: formData[1].jrf_lab,
                commodity_id: formData[1].jrf_commodity,
                sub_commodity_id: formData[1].fk_sub_commodity,
                group_id: editableFormData[0]?.group_id,
                tenant: 1
            };
            if (editableFormData[0]?.is_group) {
                tempBody.group_id = editableFormData[0]?.group_id
            }
            else {
                tempBody.param_id = editableFormData[0]?.smpl_set_paramjson
            }
            let res;
            res = await postDataFromApi(labOPEGroupsStdBasisApi, tempBody);
            if (res.data && res.data.status == 200) {
                // if(editableFormData[0]?.is_group)
                let actualResponse
                if (editableFormData[0]?.is_group) {
                    actualResponse = res.data.data.parameters.find((param) => param.param_id == editableFormData[0]?.smpl_set_paramjson);
                }
                else {
                    actualResponse = res.data.data
                }
                let standards = actualResponse.standard || [];
                let basis = [];

                standards = standards.map((item) => ({
                    ...item,
                    name: item.std_name,
                    id: item.std_id,
                }));

                const unitoptions = actualResponse.param_unit.split(",").map((opt) => ({
                    name: opt,
                    id: opt,
                }));

                setUpdatedMasterOptions((prev) => {
                    const updated = [...prev];

                    const updateOrAdd = (model, data) => {
                        const index = updated.findIndex((item) => item.model === model);

                        if (index !== -1) {
                            updated[index] = {
                                ...updated[index],
                                data,
                            };
                        } else {
                            updated.push({
                                model,
                                data,
                            });
                        }
                    };
                    updateOrAdd("smpl_set_testmethodjson", standards);
                    updateOrAdd("smpl_set_basisjson", basis);
                    updateOrAdd("smpl_set_unit", unitoptions);
                    return updated;
                });
            }
        } catch (error) { }
        setTimeout(() => {
            setIsLoading(false);
        }, [10]);
    };
    const handleSampleInwardSetUpdate = async (groupJson, paramjson) => {
        try {
            let payload = {
                smpl_set_id: formData[0]?.sample_set_data[editableSetIndex]?.smpl_set_id,
                sample_set_data: {
                    "sample_inward_id": formData[1]?.sampleInwardIdMain,
                    "sample_set_data": {
                        "smpl_set_groupjson": groupJson || [],
                        "smpl_set_paramjson": paramjson || [],
                        jila_id: sampleDataTable[editableSetIndex]?.jila_id,
                        fk_jiid: sampleDataTable[editableSetIndex]?.fk_jiid,
                        fk_jisid: sampleDataTable[editableSetIndex]?.fk_jisid,
                        tenant: GetTenantDetails(1)
                    },
                    tenant: GetTenantDetails(1)
                }
            };
            let res = await putDataFromApi(sampleInwardSetDetailsUpdateAPI, payload);
            if (res.data.status === 200) {
                getInwardTabledata(formData[1]?.sampleInwardIdMain);
                setParameterDataTable([]);
                setCustomFormData(initialCustomData);
                setIsSubmit(false);
                setIsOverlayLoader(false);
                toast.success(res.data.message, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            } else {
                toast.error(res.message, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        } catch (error) {
            console.log('---', error)
        }
        finally {

        }
    }
    const handleFieldChange = (
        sectionIndex,
        fieldName,
        value,
        type = "",
        isChecked = "",
        isOptionsDetails,
        optionDetails,
        isBlurField,
        valueName,
    ) => {
        setEditableFormData((prev) => ({
            ...prev,
            0: {
                ...prev[0],
                [fieldName]: value,
                [fieldName + '_name']: isOptionsDetails ? optionDetails?.name : '',
            },
        }));
    }
    return (
        <Card
            className="Scrollable addNewSetData"
            style={{ position: "relative" }}
        >
            <CardBody>
                <CardSubtitle className="mb-2 text-muted" tag="h6" />

                {isLoading && <Loader />}

                <table className="table table-white responsive borderless no-wrap align-middle renderTable rendertableAssignment">
                    <thead>
                        <tr>
                            {parameterEditableFields.headers.map((field) => (
                                <th key={field.name}>{field.label}</th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            {parameterEditableFields.rows.map((cell) => (
                                <td key={cell.name}>
                                    {cell.name === "smpl_set_paramjson" ? (
                                        editableFormData?.[0]?.smpl_set_paramjson_name
                                    ) : cell.name === "smpl_set_basisjson" ? (
                                        editableFormData?.[0]?.smpl_set_basisjson_name
                                            ?.map((item) => item)
                                            .join(", ")
                                    ) : cell.name === "smpl_set_unit" ? (
                                        editableFormData?.[0]?.smpl_set_unit
                                    ) : (
                                        <RenderFields
                                            field={{
                                                ...cell,
                                                name: cell.name,
                                                multiple: cell.isMultiple
                                            }}
                                            sectionIndex={0}
                                            fieldIndex={0}
                                            formData={editableFormData}
                                            handleFieldChange={handleFieldChange}
                                            formErrors={[]}
                                            renderTable
                                            tableIndex={0}
                                            customName={cell.name}
                                            masterOptions={updatedMasterOptions}
                                            from="Table"
                                        />
                                    )}
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>

                <div className="button_container">
                    <button
                        type="button"
                        className="submitBtn btn btn-primary"
                        onClick={() => setIsEditableSetRow(false)}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="submitBtn btn btn-primary"
                        onClick={() => onHandleChangeParam()}
                    >
                        Update
                    </button>
                </div>
            </CardBody>
        </Card>
    );
};

export default EditabeAssignmentParam;